@use "../../scss/variables.scss" as *;


:host {
    --mdc-shape-small: 0px;

    display: block;
    width: 100%;
    margin: 0;

    div.wf-product-tile {
        padding: 0 12px;
    }

    a {
        text-decoration: none;
        color: currentcolor;
    }

    .image {
        position: relative;
        padding: 2rem 0;
        text-align: center;
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;

        &.only-image {
            display: flex;
        }
    }

    .product-name {
        display: block;
        height: 3rem;
    }

    .manufacturer-name {
        font-weight: normal;
        font-size: .9rem;
        padding: .5rem 0;
    }

    div.product-highlights {
        ul.details {
            list-style: none;
            padding: 0;
            margin: 0;

            display: flex;
            flex-flow: row nowrap;
            gap: 8px;
        }

        li.detail {
            backdrop-filter: var(--wf-product-tag-backdrop-filter, invert(0.02));
            user-select: none;
            padding: 4px 8px;
            border-radius: 8px;
            border: solid 1px var(--wf-gray-02, $wf-gray-02);
            font-weight: normal;
            font-size: .75rem;
        }
    }

    div.product-price {
        padding: 1rem 0;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;

        wf-price {
            width: auto;
        }

        .nutrition-information {
            font-size: 0.75rem;
            color: var(--vx-price-detail-text-color, #908787);

            a:hover {
                text-decoration: underline;
            }
        }
    }

    wf-awards.awards {
        position: absolute;
        left: 0;
    }

    wf-badges.badges {
        position: absolute;
        right: 16px;
    }

    .wf-product-tile-condensed {
        @media screen and (max-width: 480px) {
            .product-name {
                height: 3rem;
            }

            .manufacturer-name {
                height: 2rem;
            }

            wf-awards {
                scale: 0.8;
                transform-origin: top left;
            }

            wf-badges {
                scale: 0.8;
                transform-origin: top right;
            }

            .product-price > div:first-child {
                scale: 0.8;
                transform-origin: top left;
            }
        }
    }
}
